var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "14px",
    viewBox: "0 0 17 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B9D59F4E-82F7-43C4-BCBC-BF5CC9A44ED9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Relationship-Tracker",
    transform: "translate(-1167.000000, -86.000000)",
    fill: "#A28014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(1157.482884, 80.777633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(9.765115, 5.807779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-filled-tool-symbol",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86269321,6.10551012 C4.99828259,6.25306327 5.07272382,6.44581288 5.07272382,6.64520903 L5.07272382,12.5207489 C5.07272382,12.8743581 5.49943158,13.0538146 5.75200004,12.8052208 L7.39103639,10.926909 C7.61037216,10.6637061 7.73133916,10.5334207 7.73133916,10.2728897 L7.73133916,6.64653834 C7.73133916,6.44714219 7.80710969,6.25439258 7.94136977,6.10682613 L12.644447,1.00362729 C12.9967135,0.620786681 12.7255481,0 12.2044462,0 L0.599590227,0 C0.0785016209,0 -0.194006451,0.619457373 0.159589389,1.00362729 L4.86269321,6.10551012 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    transform: "translate(12.803450, 7.744498) scale(1, -1) translate(-12.803450, -7.744498) ",
    points: "12.8034502 6.46034719 16.0551912 9.02864831 9.55170913 9.02864831"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.b46712ed36caedf4ad25de949e131d96.svg";
export { ForwardRef as ReactComponent };